import React, { FC, useState } from 'react';

import classNames from 'classnames';

import { IconProps } from '../../shared/ui';

export const EmailIcon: FC<IconProps> = ({
  width = 40,
  height = 40,
  fillBg = '#C00000',
  className,
  needHover = true,
}) => {
  const [hover, setHover] = useState(false);

  return (
    <svg
      onMouseMove={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
      className={classNames(className, { 'cursor-pointer': needHover })}
      width={width}
      height={height}
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="40" height="40" rx="10" fill={hover && needHover ? '#111026' : fillBg} />
      <rect x="11" y="13.5" width="18" height="13" rx="2.5" stroke="white" strokeWidth="1.6" />
      <path d="M11.5 15.5L20 21L28.5 15.5" stroke="white" strokeWidth="1.6" strokeLinecap="round" />
    </svg>
  );
};
